import type { z } from "zod";

import { idNameSchema } from "./generic-schema.ts";

// GET Request Schemas //

// Endpoint: /api/carrier-selection/service-levels
export const serviceLevelSchema = idNameSchema;

export type ServiceLevel = z.infer<typeof serviceLevelSchema>;
